"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kyber = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const KYBER_STORAGE_ABI = require("../../abi/kyberStorage.json");
const KYBER_HINT_ABI = require("../../abi/kyberHint.json");
const KYBER_PROXY_ABI = require("../../abi/kyberProxy.json");
const MAX_DEST_AMOUNT = '57896044618658097711785492504343953926634992332820282019728792003956564819968';
const KYBER_FEE_WALLET = '0x52262274dF4dB2586407F95454dea18eC1153662';
const DEX_PARAMS = {
    1: {
        kyberStorage: '0xC8fb12402cB16970F3C5F4b48Ff68Eb9D1289301',
        kyberHint: '0xa1C0Fa73c39CFBcC11ec9Eb1Afc665aba9996E2C',
    },
};
class Kyber extends adapter_1.default {
    constructor() {
        super(...arguments);
        this.getKyberReservesToExclude = (token, isSrc) => __awaiter(this, void 0, void 0, function* () {
            const kyberStorageContract = new this.web3Provider.eth.Contract(KYBER_STORAGE_ABI, DEX_PARAMS[this.network]['kyberStorage']);
            if (isSrc) {
                const srcTokenReserveIds = yield kyberStorageContract.methods
                    .getReserveIdsPerTokenSrc(token)
                    .call();
                return srcTokenReserveIds.filter((srcTokenReserveId) => srcTokenReserveId.substring(0, 4) === '0xbb');
            }
            else {
                const destTokenReserveIds = yield kyberStorageContract.methods
                    .getReserveIdsPerTokenDest(token)
                    .call();
                return destTokenReserveIds.filter((destTokenReserveId) => destTokenReserveId.substring(0, 4) === '0xbb');
            }
        });
    }
    static getDexData(optimalRate, name) {
        return {
            name,
            exchange: optimalRate.data.exchange,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            minConversionRate: '1',
        };
    }
    buildHint(srcToken, destToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const kyberHintContract = new this.web3Provider.eth.Contract(KYBER_HINT_ABI, DEX_PARAMS[this.network].kyberHint);
            //ethToToken
            if (this.isETHAddress(srcToken)) {
                const excludedReserves = yield this.getKyberReservesToExclude(destToken, false);
                return yield kyberHintContract.methods
                    .buildEthToTokenHint(destToken, 2, excludedReserves, [])
                    .call();
            }
            //tokenToEth
            else if (this.isETHAddress(destToken)) {
                const excludedReserves = yield this.getKyberReservesToExclude(srcToken, true);
                return yield kyberHintContract.methods
                    .buildEthToTokenHint(srcToken, 2, excludedReserves, [])
                    .call();
            }
            //tokenToToken
            else {
                const srcExcludedReserves = yield this.getKyberReservesToExclude(srcToken, true);
                const destExcludedReserves = yield this.getKyberReservesToExclude(destToken, false);
                return yield kyberHintContract.methods
                    .buildTokenToTokenHint(srcToken, 2, srcExcludedReserves, [], destToken, 2, destExcludedReserves, [])
                    .call();
            }
        });
    }
    _swap(srcToken, destToken, data) {
        data.maxDestAmount = data.maxDestAmount || MAX_DEST_AMOUNT;
        data.hint = data.hint || '0x';
        const kyberContract = new this.web3Provider.eth.Contract(KYBER_PROXY_ABI, data.exchange);
        const swapData = kyberContract.methods
            .tradeWithHintAndFee(srcToken, data.srcAmount, destToken, this.augustus._address, data.maxDestAmount, data.minConversionRate, KYBER_FEE_WALLET, '0', data.hint)
            .encodeABI();
        return super.swap(srcToken, destToken, data, swapData, data.exchange);
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.Kyber = Kyber;
//# sourceMappingURL=kyber.js.map